export const TRANSLATIONS_EN = {
  login: {
    username: 'Username',
    password: 'Password',
    login: 'Login',
    guest: 'Continue as Guest',
    back: 'Back to login screen',
    sevenDigitPin: '7-digit PIN',
    scan: 'Scan you card for login ',
    ticket: 'Scan your ticket to check it out ',
    switchStageLabel:
      'You are on {{current}} — click here to switch to {{target}}',
    switchStageTitle: 'Switch to {{target}}?',
    switchStageMessage:
      "Are you sure you want to change stages? This will reboot every terminal at the office. If you are not at the office, you won't see any change.",
    switchStageSwitching: 'Switching…',
    switchStageSuccess:
      'Switching to {{target}}. Terminals at the office are rebooting…',
    switchStageError: 'Could not switch stage. Please try again.',
  },
  header: {
    sales: 'Sales',
    newMember: 'New user',
    searchMember: 'Search user',
    onlinePayment: 'Online payment',
    onlinePaymentHistory: 'Online payment history',
    report: 'Report',
    playerWithBalanceReport: 'Player with balance report',
    adminReport: 'Admin Report',
    openTickets: 'Tickets Today',
    ticketHistoric: "User's Historic",
    recent: 'Recent sales',
    endShift: 'End shift',
    endShiftMessage: 'Do you want to end your shift?',
    specialGame: 'Special game',
    specialGameAvailable:
      'Special game is about to started, pay attention to the payment',
    specialGameSubtitle: 'Write the amount of the prize',
    specialGameMessage: 'This will change the prize of the last game to',
    specialGameMessageConfirm: 'The payment has been done successfully',
    specialGameMessageConfirmNoPrize:
      'The special game has been closed without winners',
    specialGameMessageError: 'There is not any open special game',
    lastTransactions: 'Last trans.',
    lastCardTransactions: 'Card trans.',
    printLastTrans: 'Print last sale',
    userLimits: 'Game limits',
    userLimitsMenuTitle: "'s limits'",
    ticketList: 'Ticket list',
    openCashier: 'Open drawer',
    refund: 'Refund',
    cashMovement: 'Cash movement',
    safe: 'Safe',
    gameplan: 'Game plan',
    mysteryWinners: 'Mystery winners',
    terminals: 'Terminals',
  },
  kiosk: {
    comeBack: 'Come back',
    kioskBlock: 'This point of sale is disabled.',
    kioskBlockMessage1: 'This point of sale is not assigned to any bingo hall.',
    kioskBlockMessage2:
      'If you are reading this message, please, contact with support.',
    wrongUserTitle: 'User not found',
    wrongUserMessage1:
      "We couldn't find any user with these credentials in the system.",
    wrongUserMessage2:
      "Please check the information you've provided or contact support.",
    orderList: 'My order',
    total: 'Total',
    done: 'Done',
    guest: 'Guest',
    phonenumber: 'Phone number',
    sevenDigitPin: '7-digit PIN',
    logout: 'Logout',
    clear: 'Clear',
    price: 'Price',
    totalPrice: 'Total price',
    tickets: 'Tickets',
    delete: 'Delete',
    confirmLogoutTitle: 'Are you sure you want to logout?',
    confirmLogoutMessage:
      'You have pending transactions that will be canceled if you logout.',
    pageIndicator: 'Page {{current}} / {{total}}',
    noGamesAvailable: 'No games available',
    priceCardLabel: 'Price card',
    gameLabel: 'Game',
    confirmPaymentTitle: 'Payment method',
    confirmPaymentMessage: 'How do you want to pay the current order?',
    payWithCard: 'Pay with card',
    payWithSaldo: 'Pay with balance account',
    currentSaldo: 'Current balance',
    paymentNotAvailable: 'Not available',
    waitingForCard: 'Waiting for reading the card',
    paymentSuccess: 'The payment has been completed successfully',
    errorPaymentTitle: 'There was an error with the payment',
    errorPaymentMessage:
      'Something went wrong during the payment process, please try again or use another payment method.',
    blockedToBuyDataBingoInUse:
      'The ticket is currently in use on another terminal and cannot be closed.',
    blockedToBuyDataBingoTitle:
      'You are not allowed to buy more data bingo tickets',
    blockedToBuyDataBingoMessage:
      'You have reached the limit for purchasing data bingo tickets.',
    blockedToBuyDataBingoZeroBalance:
      'The existing ticket has no balance. If you want to create a new one, you must close this ticket first.',
    blockedToBuyDataBingoCloseTicket: 'Close ticket',
    limitSurpassedTitle: 'Limit surpassed',
    limitSurpassedMessage:
      'You have surpassed the limit for purchasing tickets. Please, adjust your purchase accordingly.',
    infoTicketTitle: 'Ticket information',
    infoTicketMessage1: 'Current saldo: ',
    infoTicketMessage2:
      'If you are the owner of this ticket, you can refill it logging in.',
    infoTicketMessage3: 'If you want to pay it out, please go to the cashier.',
    infoTicketErrorTitle: 'Invalid ticket',
    infoTicketErrorMessage:
      'The scanned ticket is not valid or could not be found. Please, try with another ticket.',
    closedTicketTitle: 'Closed ticket',
    closedTicketMessage1: 'This ticket is closed and cannot be used.',
    closedTicketMessage2: 'Please contact the cashier for more information.',
    usedTicketTitle: 'Ticket in use',
    usedTicketMessage1: 'This ticket is currently in use on a machine.',
    usedTicketMessage2:
      'The ticket must be logged out from the machine before it can be used here.',
    selectTicket:
      'Please, select one ticket first before choosing the amount to refill.',
    infoTicketErrorPinMessage: 'The PIN code is not correct, please try again.',
    confirmPinTitle: 'Confirm your identity',
    confirmPinMessage1:
      'In order to let you operate with this account, we need to confirm your identity.',
    confirmPinMessage2: 'Please, enter your 4-digit PIN code to continue.',
    outOfPaperTitle: 'Printer out of paper',
    outOfPaperMessage:
      'The printer is out of paper. Please, contact support to solve this issue.',
    paperLowTitle: 'Paper running low',
    paperLowMessage:
      'The printer is running low on paper. Please refill it soon to avoid interruptions.',
    printerOfflineTitle: 'Printer offline',
    printerOfflineMessage:
      'The printer is not reachable. Please check the connection or contact support.',
    transactionGameExpired:
      'One or more games have passed their cutoff time and were removed from your cart.',
    cutoffRemaining: 'Closes in',
  },
  sales: {
    checkCard: 'Check',
    openShiftTitle: 'Open shift not found',
    openShiftText:
      'No open shift has been found for this terminal. A new one shift will be created if you continue.',
    cashOnOpening: 'Cash on opening',
    openShiftOperator: 'Operator',
    openShiftHall: 'Hall',
    openShiftConfirmTitle: 'Confirm cash on opening',
    openShiftAmountLabel: 'You are opening the day with',
    openShiftCountedQuestion:
      'Do you confirm that you have counted the cash drawer?',
    openShiftBack: 'Back',
    cashMovementTitle: 'Cash movement',
    cashMovementSubtitle: 'What kind of movement is this?',
    cashMovementRefund: 'Refund to a player',
    cashMovementOut: 'Take cash out of the till',
    cashMovementIn: 'Put cash into the till',
    cashMovementSafe: 'Safe and mini safe',
    cashMovementKiosk: 'Kiosk sales',
    kioskProductsTitle: 'Kiosk items sold',
    kioskProductsShift: 'This shift',
    kioskProductsDay: 'Whole day',
    kioskProductsProduct: 'Item',
    kioskProductsQty: 'Qty',
    kioskProductsTotal: 'Total',
    kioskProductsEmpty: 'No kiosk items sold',
    kioskProductsCancelled: '{{count}} cancelled',
    kioskProductsCount: '{{count}} items',
    cashMovementAmount: 'Amount',
    cashMovementReason: 'Reason',
    cashMovementReasonHelp:
      'Write what the money went to or came from. Short is fine.',
    cashMovementReasonRequired: 'A reason must be filled in.',
    cashMovementAmountRequired: 'Enter an amount.',
    cashMovementNoPlayer: 'Select a player first to make a refund.',
    cashMovementDone: 'The movement has been recorded.',
    handoverTitle: 'Taken over from the previous shift',
    handoverSignedBy: 'Signed by',
    handoverClosedAt: 'Closed',
    handoverAvvik: 'Discrepancy at the previous close',
    openingAvvik: 'Difference against the previous close',
    openingMatches: 'Matches the previous close',
    openingCommentLabel: 'What did you find?',
    openingCommentHelp:
      'Count again first if you can. Write what you found — you were not on the previous shift.',
    openingCommentRequired:
      'A difference at opening must be noted before the shift can be opened.',
    openingRecount: 'Count again',
    terminalsTitle: 'Terminals',
    terminalsID: 'ID',
    terminalsType: 'Type',
    terminalsSoftReset: 'Soft Reset',
    terminalsReboot: 'Reboot',
    terminalsScreenshots: 'Screenshots',
    terminalsScreenshotsTitle: 'Screenshots — {{deviceType}} {{id}}',
    terminalsScreenshotsError: 'Could not load screenshots from this terminal',
    terminalsScreenshotsFullscreen: 'Fullscreen',
    terminalsBack: 'Back',
    terminalsTypeFlash: 'Flash',
    terminalsTypeTerminal: 'Terminal',
    terminalsTypeKiosk: 'Self-service',
    terminalsConfirmSoftResetTitle: 'Soft reset of {{deviceType}} {{id}}',
    terminalsConfirmRebootTitle: 'Reboot of {{deviceType}} {{id}}',
    terminalsConfirmSoftResetText:
      'Are you sure you want to apply a soft reset to the {{deviceType}} {{id}}? Please, be aware nobody is currently using this.',
    terminalsConfirmRebootText:
      'Are you sure you want to reboot the {{deviceType}} {{id}}? Please, be aware nobody is currently using this.',
    terminalsActionSuccess: 'Action done successfully',
    terminalsRebootAll: 'Reboot all',
    terminalsSoftResetAll: 'Soft reset all',
    terminalsConfirmSoftResetAllTitle: 'Soft reset all terminals',
    terminalsConfirmRebootAllTitle: 'Reboot all terminals',
    terminalsConfirmSoftResetAllText:
      'Are you sure you want to apply a soft reset to all terminals? Please, be aware nobody is currently using them.',
    terminalsConfirmRebootAllText:
      'Are you sure you want to reboot all terminals? Please, be aware nobody is currently using them.',
    noData: 'No data available',
    expiredPepTitle: 'PEP User',
    expiredPepQuestionPep: 'Is the user still a PEP?',
    expiredPepQuestionNotPep: 'Is the user still not a PEP?',
    expiredAddressTitle: 'Address details',
    expiredAddressQuestion: "Is the user's address still the same?",
    expiredAddressValues:
      'Country: {{country}}, Postal code: {{postalCode}}, Street address: {{streetAddress}}',
    expiredContactTitle: 'Contact details',
    expiredContactQuestion: "Is the user's phonenumber still the same?",
    expiredContactValues: 'Phonenumber: {{mobile}}',
    expiredBack: 'Back',
    userID: 'User ID',
    gameID: 'Game ID',
    bingoName: 'Hall',
    date: 'Date and time',
    winnerCard: 'Winner Card',
    noMysteryWinnersTitle: 'No mystery winners found',
    noMysteryWinnersText:
      'There are no mystery winners to show at this moment.',
    expiredTitle: "User's information expired",
    expiredText:
      " The user's information has expired and needs to be updated before continuing.",
    unlockTitle: 'Unlock user',
    unlockText1: 'You are going to unlock this user. The details are:',
    unlockText2: 'Are you sure you want to unlock this user?',
    unlockedTitle: 'User unlocked successfully. ',
    unlockedText: 'Press confirm to continue.',
    lockTitle: 'This user is not locked',
    lockText1: 'This user is not locked, you can sell normally.',
    lockText2: 'Press confirm to continue.',
    cashin: 'Cash in',
    cashout: 'Cash out',
    rollover: 'Rollover winnings',
    totalSpentDay: 'Total spent',
    limitsPerDay: 'Limits per day',
    winnings: 'Winnings',
    description: 'Description',

    refund: 'Refund amount',
    refundCash: 'in cash',
    refundLimits: "Accounting for user's limits",
    refundReason: 'Reason',
    gameSelector: 'Game selection',
    confirmAndClose: 'Confirm and close',
    backToMainScreen: 'Back to sales',
    startTime: 'Start time: ',
    bet: 'Bet',
    cards: 'Cards',
    betAndCardsMustBeSelected:
      'You must select bet and cards before finish the sale',
    sell: 'Sell',
    selectGameAndCards: 'Select game and cards',
    confirmAndContinue: 'Confirm and continue',
    done: 'Done',
    confirmPapirBatchText:
      'Sell {{cards}} cards for games <hl>{{games}}</hl> for a total of <hl>{{total}} kr</hl>?',
    confirmBatchWithBet:
      'Sell {{cards}} cards with bet {{bet}} for games <hl>{{games}}</hl> for a total of <hl>{{total}} kr</hl>?',
    confirmPapirBatchWithPrice:
      'Sell {{cards}} cards at {{price}} kr each for games <hl>{{games}}</hl> for a total of <hl>{{total}} kr</hl>?',
    confirmKingoSaleTitle: 'Confirm the sale',
    confirmKingoSaleText1: 'You are going to sell ',
    confirmKingoSaleText2: ' cards with a bet of ',
    confirmKingoSaleText3: ' each, for a total of ',
    confirmKingoSaleText4: 'Do you want to continue?',
    papirBatchTitle: 'List of tickets scanned',
    papirBatchText1:
      'The following tickets have been scanned in this receipt. If you want to pay it out, scann the winner ticket:',
    papirBatchText2:
      'The following tickets have been scanned in this receipt. If you want to pay it out, please go to the cashier:',
    papirBatchNotFinished: 'Not finished',
    papirBatchNotPrize: 'No prize',
    papirBatchPrize: 'Prize: ',
    papirBatchInvalidHall: 'Invalid hall',
    papirInstructions:
      'Scan the cards and the sell will be managed automatically by the system. If you need to cancel a card, do it before coming back to the main screen',
    price: 'Price: ',
    papirTicketAlreadySoldTitle: 'This ticket has been already sold',
    papirTicketAlreadySoldText:
      'If you want to check the results, scan the ticket again on the main screen',
    papirTicketNotSoldTitle: 'This ticket is not sold yet today',
    papirTicketNotSoldText1:
      'The scanned ticket is not sold nor link to any user today.',
    papirTicketNotSoldText2:
      'If you want to sell it, go to the Paper Bingo screen.',
    papirTicketNotSoldText3:
      'During the last 7 days, this ticket has the following history:',
    papirTicketAmount: 'Amount',
    papirTicketTransaction: 'Transaction',
    papirTicketDate: 'Date',
    papirTicketGameID: 'Game ID',
    papirTicketSold: 'Sold',
    papirTicketCancel: 'Cancelled',
    papirTicketPrizes: 'Prizes',
    papirTicketPrizesPayout: 'Was cash out',

    restoreSaleTitle: 'Unfinished sale found',
    restoreSaleText1:
      'The screen was closed in the middle of a sale. It was saved on this machine.',
    restoreSaleClient: 'Client: ',
    restoreSaleNoUser: 'no client',
    restoreSaleOperator: 'Registered by: ',
    restoreSaleTime: 'Time: ',
    restoreSaleLines: 'Lines: ',
    restoreSaleTotal: 'Total: ',
    restoreSaleQuestion: 'Do you want to restore the sale?',
    restoreSaleYes: 'Restore',
    restoreSaleNo: 'Discard',

    papirTicketNotValidTitle: 'This ticket is not valid for selling',
    papirTicketNotValidText1: 'The scanned ticket is not valid for selling.',
    papirTicketNotValidText2: 'Reason: ',
    papirTicketNotValidText3: 'Please, try with another ticket.',
    papirTicketNotValidReasonPrice:
      'The type of ticket is not correct for the selected game.',
    papirTicketNotValidReasonHall: "This ticket doesn't belong to this hall.",
    papirTicketNotValidReasonPriceAndHall:
      "The type of ticket is not correct for the selected game and it doesn't belong to this hall.",

    papirGameNotFinishedTitle: 'This game is not finished',
    papirGameNotFinishedText1:
      'The game asociated to this ticket has not been played yet',
    papirGameNotFinishedText2: 'The game number ',
    papirGameNotFinishedText3: ' starts at:  ',
    papirGameNotFinishedText4:
      'Check it later to see if the ticket has any prize. ',

    papirGameFinishedWithPrizeTitle: 'This ticket has a prize',
    papirGameFinishedWithPrizeText1: 'This ticket has the following prizes:',
    papirGameFinishedWithPrizeText2: 'Do you want to cash out the prizes?',
    papirGameFinishedWithPrizeText3:
      'Please, go to the cashier to do the payout.',
    papirGameFinishedWithPrizeIsAlreadyPayed:
      'This ticket has been already pay out',
    papirGameFinishedWithPrizeUserTotal: 'Total',
    papirGameFinishedWithPrizeUserMustBeLogin:
      'The amount is bigger than 500. Please, identify the user before doing the payout.',

    papirGameFinishedWithoutPrizeTitle: "This ticket doesn't any prize",
    papirGameFinishedWithoutPrizeText1:
      "This ticket doesn't have any prize on its game.",
    papirGameFinishedWithoutPrizeText2:
      'If you want to check another prize, please scan it after close this dialog.',

    papirCheckCardTitle: 'Card check',
    papirCheckCardSubtitle: 'Replay the draw to verify the card',
    papirCheckCardDrawnBalls: 'Rop drawn',
    papirCheckCardLastBall: 'Last ball',
    papirCheckCardWinningBall: 'Winning ball',
    papirCheckCardResult: 'Result',
    papirCheckCardStart: 'Start',
    papirCheckCardPrevious: 'Previous',
    papirCheckCardNext: 'Next',
    papirCheckCardPlay: 'Play',
    papirCheckCardPause: 'Pause',
    papirCheckCardBallNumber: 'Ball',
    papirCheckCardCard: 'Card',
    papirCheckCardGame: 'Game',
    papirCheckCardMatches: 'Matches',
    papirCheckCardSummary: 'Card summary',
    papirCheckCardPatternBilde: 'Bilde',
    papirCheckCardPatternRamme: 'Ramme',
    papirCheckCardPatternBingo: 'Bingo',
    papirCheckCardNoPrize: 'No prize on this card',
    papirCheckCardTotal: 'Total',
    papirCheckCardLimit: 'limit',

    paper: 'Paper bingo',
    countdownToNextGame1: 'The next game is ',
    countdownToNextGame2: ' and the selling will close in:  ',
    transactions: 'Transactions',
    printAction: 'Print',
    scanMessage: 'Scan or look for an user, or sell to an anonymous user',
    gameMustBeSelected: 'You must select a game before sell the ticket',

    search: 'Search for an user',
    searchMemberPin: 'Search by pin',
    searchMemberUsername: 'Search by username',
    searchMemberPhonenumber: 'Search by phone number',
    autoSearch: 'Auto search',
    searchByFirstname: 'Search by first name',
    searchByLastname: 'Search by last name',
    searchBySSNID: 'Search by SSN ID',
    deposit: 'Deposit',
    depositSubtitle: 'To player account',
    withdraw: 'Withdraw',
    withdrawSubtitle: 'From player account',
    transfer: 'Bank Transfer',
    transferSubtitle: 'To bank account',
    newTicket: 'New ticket',
    payout: 'Payout',
    scan: 'Scan',
    refill: 'Refill',
    product: 'New product',
    cash: 'Cash',
    card: 'Card',
    spillerkonto: 'Player account',
    printMovement: 'Account Statement',
    saldoUserAccount: ' User balance: ',
    newCardMessage:
      'This card is not register, do you want to create a new user?',
    paymentCard: 'Finish this shop and pay by card?',
    paymentCash: 'Finish this shop and pay by cash?',
    yes: 'Yes',
    no: 'No',
    part: 'Split',
    partialAmount: 'Choose amount',
    confirmAndStay: 'Confirm and stay',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    cardPaymentItem: 'Cash withdrawal',
    confirmWG:
      'To continue, you need first to finish the operation in the Win Games cashier.',
    confirmOK:
      'To continue, you need first to finish the operation in the OK Databingo cashier.',
    confirmNT:
      'To continue, you need first to finish the operation in the Norsk Tipping cashier.',
    saldoUserAccount: ' Saldo på spillerkonto: ',

    total: 'Total',
    payCard: 'Payed by Card',
    payCash: 'Payed by Cash',
    payAccount: 'Payed by Account',
    change: 'Change',
    remaining: 'Remaining',

    paymentCardScreen: 'Payment by card',
    paymentCashScreen: 'Payment by cash',
    paymentFullCard: 'Pay total',
    paymentFullCash: 'Pay total',
    amount: 'Amount',
    endShop: 'Do you confirm the transaction is done?',
    endShopByCard:
      'Do you confirm the transaction is done? After confirm it, wait for the user payment',
    insufficientFunds: 'The transactions are not payed yet',
    waiting: 'Waiting for the user payment',
    cancelShop: 'Cancel buy',
    print: 'Print receipt',
    shortcuts: 'Shortcuts amount',
    payCard: 'Card Payment',
    payCardSingle: 'Single Card Payment',
    payCash: 'Cash Payment',
    payCHTitle: "Pay with player's account",

    payCH: "Player's account",
    payoutTicket: 'Open tickets',
    registerNewAnonUser: 'New Anon User',
    registerNewHybridUser: 'New Daily User',
    registerNewMember: 'New Member',
    editHybridUser: 'Edit Daily User',
    editMember: 'Edit Member',
    optional: '(optional)',
    userTooSmall: 'Search should have at least 7 digits',
    userNotFound: "The user doesn't exist, do you want to create a new one?",
    usersFound: 'More than one user has been found',
    selectUser: 'Use this user',

    registerNewUserConfirm: 'Register new user',
    editUserConfirm: 'Edit new user',
    anonToUser:
      'Do you want to edit the current daily user or register it as a new member?',
    hybridToUser:
      'Do you want to edit the current daily user or register it as a new member?',
    phonenumber: 'Phonenumber',
    newUser: 'New daily user',
    newMember: 'New member',
    newMemberText:
      'The costumer must confirm their identity. Ask the costumer which method they want to use to verify their identity.',
    newMemberButtonID: 'ID Card, Driver License or Passport',
    newMemberButtonBankID: 'BankID',
    updateHybridUser:
      'This is a daily user, you can edit it or register it as a new member:',
    lastUsers: 'Last users',
    sellMessage:
      'Remember to receive cash from the customer before pressing TOTAL',
    sellMessageCash1: 'Remember to take ',
    sellMessageCash2: ' KR from the costumer. ',
    sellMessageReturnCash1: 'Remember to give back ',
    sellMessageReturnCash2: ' KR to the costumer. ',
    name: 'Name',
    surname: 'Surname',
    nameAndSurname: 'Name and surname',
    unblock: 'Send confirmation to the user to unlock the tickets',
    send: 'Send',
    unregistered: 'Unregistered',
    registerAnonPlayer: 'Register the daily user',
    paymentAnon:
      'Daily players only can pay by card, do you want to register this daily user?',
    registerAnonPlayerConfirm: 'Register',
    transactionDone: 'Transaction complete',
    backToPayment: 'Return to the payment',
    transactionFail: 'Transaction failed or declined',
    smsTitle: 'Waiting for pincode',
    smsText1:
      "An SMS with a pincode has been sent to customer's mobile number to confirm his identity. ",
    smsText2: 'The costumer has to confirm the pincode in the screen.',
    pincodeTitle: "Waiting for user's pin",
    pincodeText1:
      'The user should introduce the 4 digit pincode associated with his account: ',
    userConfirm: 'Successfully registered user',
    selected: 'Selected',
    internetAccess: 'Forbid internet access',

    chooseOne: 'Choose one...',
    passport: 'Passport',
    driverLicense: 'Driver License',
    electronicID: 'Electronic(BankID)',
    bankCard: 'Bank card',
    nationalID: 'National ID',
    other: 'Other',
    terms: 'Terms of Use and Privacy Policy',
    communication: "User's communication preferences",
    pincode: 'Generate a pincode',
    newPincode: 'Ny pinkode',
    pincodeLabel: 'Pincode',
    cardID: 'Card ID',
    nfcCardID: 'NFC Card ID',
    ssnid: 'SSN ID',
    username: 'Username',
    firstname: 'First Name',
    lastname: 'Last Name',
    address: 'Address',
    verificationMethod: 'Verification Method',
    country: 'Country',
    postalCode: 'Postal Code',
    region: 'Region',
    email: 'Email',
    birthdate: 'Birthdate',
    verificationID: 'Verification ID',
    bankAccount: 'Bank Account',
    cashoutPending: 'The user has a pending cash out :',
    cashoutNow: 'Cash out now',
    signatureTitle: 'Signature required',
    signatureText:
      "The current transaction needs to be signed to be approved. Waiting for the user's signature.",
    signatureTitleID: 'ID confirmation required',
    signatureTextID:
      "An ID confirmation is required to continue. Take a picture of the user's ID to verify the user's identity.",
    signatureConfirmSMS: "A pincode will be sent to the user's phone",
    signatureUserNeedsMobile:
      'This user has not a phone number registered. A phone number is mandatory to proceed. ',
    signatureConfirm: 'Transactions approved',
    openSessionTitle: 'Open session found',
    openSessionText1: 'This ticket has an open session in the terminal ',
    openSessionText2: ' with a total amount of ',
    openSessionTextClose: 'Do you want to close the session?',
    openSessionTextUnclosable:
      'This session need to be closed in the terminal first',
    chooseProduct: 'Choose a product',

    ticket7Pincode: 'Ticket Pincode',
    currentSaldo: 'Current Saldo',
    editHybridToFull: 'Convert into member',
    userLimits: 'User Limits',
    noLimits: 'No limits',
    cashIn: 'Cash In',
    cashOut: 'Cash Out',
    limitsUpdated: 'Limits updated for this user',
    cardToCash: 'Cash withdrawals',
    limitDaily: 'Daily limit',
    limitMonthly: 'Monthly limit',
    isLimitSurpassed: 'Limit surpassed',
    isLimitSurpassedDaily:
      'This user has surpassed the limit and is not allowed to play more today',
    isLimitSurpassedMonth:
      'This user has surpassed the limit and is not allowed to play more this month',
    isVerificationNeeded: 'Verification required',
    isVerificationNeededText1:
      "The user's profile lacks several important information and needs to be verified to continue",
    isVerificationNeededText2: 'Please edit the user to verify it.',
    isLimitSurpassedTransaction1:
      "The current transaction is not allowed because it surpasses the user's limit.",
    isLimitSurpassedTransaction2: 'The maximum amount allowed is: ',
    ticketWithDifferentParentTitle: "This ticket doesn't belong to this user",
    ticketWithDifferentParentText:
      'This ticket belongs to another user, do you want to make the payout for the current user?',
    photoVerificationTitle: "This user doesn't have a verified photo",
    photoVerificationText:
      "Do you want to verify the user's photo? Take a picture of the user or user's ID to verify the user's identity.",

    photoUploadTitle: 'Take the picture',
    photoUploadText:
      'Use one of the cameras to take a picture of the user face or any other valid document, like a passport or ID card.',
    photoUploadTextSignature:
      'Use one of the cameras to take a picture of any user valid document, like a passport or ID card.',
    photoUploadSuccess: 'The picture has been uploaded successfully',
    userVerificationImage: 'User verification image',
    userVerificationImageNew: 'Take a new image',
    saldo: 'Balance',
    status: 'Status',
    open: 'Open',
    closed: 'Closed',
    inGame: 'In game',
    ticketClosedOK: 'This ticket is already closed',
    editUserBlock: 'Finish the current operation to edit the user',
    editUserConfirmButton: 'Edit',
    bigNumberConfirmTitle: 'Transaction over 10.000',
    bigNumberConfirmText1:
      'The amount of this transaction is higher than the usual, do you want to continue?',
    bigNumberConfirmText2: 'Total amount: ',
    deleteUser: 'Delete user',
    banUser: 'Disable user',
    banUserTitle: 'Disable user',
    banUserText:
      'Are you sure you want to disable this user? Select the reason and for how long you want to disable the user.',
    banUserTextConfirm: 'You are going to disable the user for: ',
    banUserTextConfirmSuccess:
      'The user has been disable. To activate it again, contact with support.',
    banUserReason: 'Reason',
    banUserReasonPlaceholder: 'Select a reason',
    banUserDuration: 'Duration',
    banUserDurationPlaceholder: 'Select a duration',
    deleteUserTitle:
      'You are going to delete this user, are you sure you want to continue?',
    deleteUserConfirm: 'The user has been deleted',
    closeSellerOrPayment:
      'Finish the current operation or come back to the main screen to scan a new ticket',
    invalidTicket: 'Invalid ticket',
    userSignatureCheckTitle: 'Identification check required',
    userSignatureCheckText:
      'Ask the customer for a valid document to verify the signature. Remember that you will need to take a picture of the document if you approve the signature.',
    newSpecialGameLuckyDay: "New 'Lucky Day' roulette",
    newSpecialGameLuckyDayText1:
      "A new 'Lucky Day' roulette has been played in this hall.",
    newSpecialGameLuckyDayText2:
      'The user need to match the number of the roulette with the current day of the month to win the prize.',
    newSpecialGameLuckyDayText3: 'Today is: ',
    newSpecialGameLuckyDayText4: 'Has the user got the right number?',
    restart: 'Restart',
    reason: 'Reason: ',
    switchCamera: 'Switch camera',
    specialGameMessageNoPrizeConfirm:
      "The user hasn't won the special prize, and the game will pay the standard bingo prize and the bildes and rammes if they exist. Do you want to continue?",
    termsSignature:
      "In order to proceed and store the user's signature, the user must agree with the Privacy Policy and accept that the id will remain store in our systems up to two years.",
    signatureStored: 'Signature stored',
    signatureStoredText:
      'The user already has a stored valid identification, check the identity of the user and confirm to continue the transaction.',
    signatureStoredDate: 'Identification stored on',
    postponeIdentification: 'Postpone identification',
    postponeIdentificationText:
      'Postpone the identification for this transaction and continue with the payment (the user will need to verify the identification within the next 2 weeks.)',
    waitingForScan: 'Waiting for a card scan',
    waitingForScanText:
      'Scan one of the CH cards to attach to this user automatically',
    pep: 'P.E.P. or close relative is P.E.P.',
    waitingForUser: 'Waiting for user',
    waitingForRiskyInfo: 'The user must provide additional information',
    waitingForUserTerms: 'The user must accept the terms of use',
    waitingForUserPEP:
      'The user must confirm if he is a P.E.P. and fulfill the form',
    waitingForUserCommunication:
      'The user must select communication channels we can use',
    waitingForUserPincodeTitle: "Waiting for user's PIN code",
    waitingForUserPincodeText:
      'The user should enter the 4-digit PIN code associated with their account',
    newMemberBankID:
      'The costumer will receive a SMS with a link to register with their BankID.',
    smsSent:
      "A SMS with a link to register and identify the user has been sent to the user's phone number",
    importantTitle: 'Important announcement',
    importantSubtitle:
      "Starting from 1st of January 2025, all daily users must be registered with a valid ID as members. If the user can't register with a valid ID right now, continue by canceling this announcement.",
    iKnowTheUser: 'I know the user',
    identityConfirm: "The user's identity has been confirmed",
    countryOfResidence: 'Country of Residence',
    confirmPicture: 'Confirm picture',
    continueWithoutRegister: 'Continue without register',
    registerAsMember: 'Register as member',

    waitingForApproval: 'Waiting for approval',
    waitingForApprovalText:
      'This user needs a manual approval to continue, please wait for the moment or contact support.',
    suspectedFraud: 'Suspected fraud',
    maxFailedLoginAttempts: 'Max failed login attempts',
    incorrectPersonalInformation: 'Incorrect personal information',
    otherBanned: 'Other',
    underaged: 'Underaged',
    hrl: 'HRL',
    pepBanned: 'PEP',
    badBehaviour: 'Bad behaviour',
    selfExclusionFor1Month: 'Self exclusion for 1 month',
    selfExclusionFor3Months: 'Self exclusion for 3 months',
    selfExclusionFor6Months: 'Self exclusion for 6 months',
    selfExclusionFor1Year: 'Self exclusion for 1 year',
    deletedAccount: 'Deleted account',
    userIsNotAllowed: 'User is not allowed to play',
    time1week: '1 week',
    time1month: '1 month',
    time3months: '3 months',
    time6months: '6 months',
    time1year: '1 year',
    riskyCountryTitle: 'You are required to provide additional information',
    riskyCountry:
      'You are from a country that required a manual approval and an extra information to continue.',
    residence: 'Residence',
    confirmLogin: "Confirm customer's identity",
    confirmLoginText:
      "Use the profile picture to confirm the customer's identity, take a new picture, ask the customer to enter the withdrawal PIN code, or confirm that you know the customer to continue.",
    confirmLoginNewMember: 'New picture',
    confirmLoginPincode: 'Withdrawal PIN',
    confirmLoginIKnowTheUser: 'Known / ID OK',
    sendPincodeBySMS: 'Send pincode SMS',
    sendPincodeBySMSText:
      "The user's pincode has been sent to the user's phone number",
    createNewUser: 'New member',
    sendOneTimeCodeBySMS: 'One time code by SMS',
    newConfirmTitle: 'The user has confirmed their identity',
    newConfirmText:
      'The user has used their withdrawal PIN to confirm their identity, press confirm to continue',
    sellBlockedTitle: 'The user has open tickets',
    sellBlockedText:
      'The user has open tickets and is not allowed to buy more tickets until the open tickets are closed',
    sellBlockedOpenTickets: 'Open tickets:',
    sellBlockedOpenSessions: 'Open sessions in',
    sellBlockedOpenTerminal: ' terminal: ',
    sellBlockedOpenBingoHall: ' hall: ',
    sellBlockedOpenBingoGame: ' game: ',
    ticketClosed: 'Ticket closed',
    closeTicket: 'Close ticket',
    closeTicketConfirmTitle: 'Close ticket',
    closeTicketConfirmMessage: 'Are you sure you want to close this ticket?',
    platform: 'Platform',
    platformKiosk: 'Self Kiosk',
    platformCashier: 'Cashier',
    provider: 'Provider',
    dateCreated: 'Date created',
    dateClosed: 'Date closed',
    dateLastRecord: 'Date last record',
    searchTicket: 'Search a ticket',
    allProviders: 'All providers',
    ticketInUse: 'In use: ',
    wgTicketInUse:
      "This Win Games tickets is currently in use and can't be cashout until it is logged out from the machine",
    openTickets: 'Open tickets',
    closedTickets: 'Closed tickets',
    allStatus: 'All status',
    searchByName: 'Search by name',
    searchByUsername: 'Search by username',
    searchByDate: 'Search by date',
    time: 'Time',
    ticketSaleID: 'Ticket Sale ID',
    forbiddenAccessTitle: "You don't have rights to manage this user",
    forbiddenAccessText:
      "You don't have the neccesary rights to manage this user. If you think this is an error, contact support.",
    userHasPasswordBlockTitle: 'This user is locked',
    userHasPasswordBlockText1:
      'This user has been locked due to too many wrong attempts on login.',
    userHasPasswordBlockText2: 'Do you want to unlock it?',
    userHasPasswordUnblockTitle: 'The user has been unlocked',
    userHasPasswordUnblockText:
      'The user has been unlocked and can login again.',
    salesDisabled:
      'Ticket sales are disabled. The only available action is to cash out.',
  },
  pep: {
    pep: 'PEP',
    customerIsPep: 'The customer is a PEP',
    customerIsNotPep: 'The customer is not a PEP',
    customerIsPepRelative: 'The customer is a close relative of a PEP',
    pepQuestion: 'Are you a Politically Exposed Person (PEP)?',
    pepDescription:
      'You are a PEP if you (or someone in your immediate family) currently hold or have previously held a high-ranking position or office in Norway or abroad.',
    pepUncertain: 'Not sure which positions apply?',
    checkList: 'Check the list here',
    positions: [
      'Head of state, head of government, minister, or deputy minister',
      'Member of a national assembly',
      'Member of a governing body of a political party',
      'Member of a supreme court or similar high-level judicial body whose decisions are rarely subject to appeal',
      'Member of the board of a national audit office, audit court, or central bank',
      "Ambassador, chargé d'affaires, or senior military officer",
      'Member of an administrative, executive, or supervisory body in a state-owned enterprise',
      'Director, board member, or other person in top management of an international organization',
    ],
    pepYes: 'I am a PEP',
    pepNo: 'I am not a PEP',
    tellWhoIsPep: 'Tell us who is a PEP',
    formPEP: 'PEP form',
    relationshipToPep: 'Your relationship to the PEP',
    name: 'Name',
    birthDate: 'Date of birth',
    gender: 'Gender',
    fundsQuestion: 'What funds will you use to play?',
    funds: [
      'Salary',
      'Sale/rental of property',
      'Sale of shares or funds',
      'Benefits, pension, student loans, or other support channels',
      'Gifts, inheritance, or similar',
    ],
    consent: 'Consent',
    consentStatements: [
      'I confirm that the bank accounts linked to my gaming account for deposits/withdrawals are in my name',
      'I confirm that the funds I will use for gaming, including cash, are legally acquired and taxed',
      'I confirm that I will personally report the balance of the gaming account to the authorities when submitting my tax return',
    ],
    male: 'Male',
    female: 'Female',
    other: 'Other',
    required:
      'You must accept all the statements to continue and choose both the relationship and the funds',
    riskyRequired:
      'You must accept all the statements to continue and choose where your funds come from',
    userNotReady: "The user hasn't finished the identification process",
  },
  communication: {
    title: 'Where can we reach you?',
    subtitle:
      'Choose where you want to receive useful information about winnings, horse betting, and other personalized content.',
    option1: 'SMS',
    option2: 'Email',
    option3: 'Receive tailored offers and news on social media',
    option4: 'Select all of the above',
  },
  terms: {
    title: 'Terms of Use and Privacy Policy',
    termsText1: "I have read and accept Bingo 1's ",
    termsText2: ' terms of use and privacy policy',
    accountText: 'The gaming account shall only be used by me *',
    required: 'You must accept the terms of use and privacy policy to continue',
  },
  error: {
    errorNotOptionSelected: 'You must select a reason first',
    notEnoughSaldo: 'The user has not enough saldo',
    waitingExternalProvider: "Waiting for the external provider's response",
    empty: 'Fields shall not be empty',
    login: 'Username or password incorrect',
    blockProvider:
      'It is not possible to sell tickets from two different databingo providers for the same user or more than one ticket',
    errorTicketNotSelected:
      'Not ticket selected. You need to select a ticket to continue with the payment.',
    userNotLogin: 'You must login an user first',
    userNotMember: 'This user is not a ClubHouse member',
    error: 'Something went wrong, try again in a moment or contact support.',
    errorTooSmall: 'The search by pin must have at least 7 digits',
    errorPhonenumber: 'The search by phone number must be 7 digits',
    errorPhonenumberInput:
      'The phonenumber is not valid. Use a valid norwegian 8 digits number',
    errorUsernameInput: "Username can't be empty",
    errorCardIDEmpty: "Card ID can't be empty",
    errorCardIDFormat: 'Card ID format is incorrect',
    errorUsernameEmpty: "Username can't be empty",
    errorUsernameTooShort: 'Username is too short, minumum 5 characters',
    errorUsernameTooLong: 'Username is too long, maximum 12 characters',
    errorFirstnameEmpty: "First name can't be empty",
    errorLastnameEmpty: "Last name can't be empty",
    errorAddress1Empty: "Address can't be empty",
    errorPostalCodeEmpty: "Postal code can't be empty",
    errorRegionEmpty: "Region can't be empty",
    errorEmailEmpty: "Email can't be empty",
    errorBirthdateEmpty: "Birthdate can't be empty",
    errorBirthdateFormat: 'Birthdate format is incorrect',
    errorCashOnOpening: 'Cash on opening cannot be empty',
    errorCashOnClosing: 'Cash on closing cannot be empty',
    errorVerificationIDEmpty: "Verification ID can't be empty",
    errorVerificationMethodEmpty: "Verification Method can't be empty",
    errorPhonenumberExists: 'Phonenumber already registered',
    errorUsernarmeExists: 'Username already registered',
    errorEmailExists: 'Email already registered',
    errorCardIDExists: 'Card ID already registered',
    errorNfcCardIDExists: 'NFC Card ID already registered',
    errorSSNIDExists: 'SSN ID already registered',
    errorUserFailCode: 'The code introduce by the user is not correct',
    errorRefreshTransactions:
      "You can't restart the cashier with pending transactions",
    errorNavigateTransactions:
      "You can't change the screen with an user logged in or with pending transactions",
    errorCode: 'Fail code',
    errorLimitSize: "The daily limit can't be lower than the monthly limit",
    errorEmptyLimits: "The limits can't be empty",
    errorImageRegister:
      "You need to verify the user's image before finish the registration",
    errorSSNIDInvalid: 'The SSN ID is not valid',
    errorSSNIDAge: 'The user is under 18 years old',
    errorCancelOpenSell:
      'For cancel the selected transaction, you need to finish this sell or come back to the main screen',
    errorPEP:
      'User must confirm if he is a P.E.P. or close relative of a P.E.P. to continue',
    errorTermsEmpty:
      'The user must accept the terms of use and privacy policy to continue',
    errorCommunicationEmpty:
      'The user must select the communication channels to continue',
    errorPincodeEmpty: 'The pincode can not be empty',
    errorRiskyEmpty: 'The user must provide additional information to continue',
    errorBankAccountEmpty: "Bank account can't be empty",
    errorBankAccountFormat:
      'Bank account must be a valid 11-digit Norwegian account number (XXXX.XX.XXXXX)',
  },
  sisteSalgs: {
    date: 'Date',
    bingoName: 'Hall',
    operator: 'Operator',
    payCard: 'Payed by Card',
    payCash: 'Payed by Cash',
    total: 'Total',
    change: 'Change',
    ticket7Pincode: 'Ticket Pincode',
    userID: 'User ID',
    ticketID: 'Ticket ID',
    username: 'Username',
    printed: 'Printed',
    transactions: 'See transactions',
    description: 'Description',
    amount: 'Amount',
    printAgain: 'Print',
    backToSells: 'Back to sells',
  },
  sisteTrans: {
    date: 'Date',
    bingoName: 'Hall',
    operator: 'Operator',
    payCard: 'Payed by Card',
    payCash: 'Payed by Cash',
    payAccount: 'Payed by Account',
    total: 'Total',
    change: 'Change',
    ticket7Pincode: 'Ticket Pincode',
    ticketID: 'Ticket ID',
    username: 'Username',
    printed: 'Printed',
    transactions: 'See transactions',
    description: 'Description',
    amount: 'Amount',
    printAgain: 'Print',
  },
  apneBilleter: {
    date: 'Date',
    bingoName: 'Hall',
    operator: 'Operatør',
    ticket7Pincode: 'Ticket Pincode',
    user7Pincode: 'User',
    ticketID: 'Ticket ID',
    description: 'Description',
    amount: 'Amount',
    printAgain: 'Print',
    seeTransactions: 'See transactions',
    username: 'Username',
  },
  ticketHistoric: {
    ticketToSearch: '7 digit ticket to search',
    date: 'Date',
    action: 'action',
    openSession: 'Opened session',
    closeSession: 'Closed session',
    payment: 'Buy cards',
    win: 'Win prize',
    cancel: 'Cancel cards',
    deposit: 'Deposit',
    depositFromPreviousSession: 'Deposit from previous session',
    saldoInit: 'Initial balance',
    saldoEnd: 'Final balance',
    bingoName: 'Hall',
    gameID: 'Game ID',
    valueChange: 'Value Change',
    searchType: 'Search type',
    userID: 'User ID',
    phone: 'Phone',
    username: 'Username',
    ownerID: 'Ticket ID',
    noResults: 'No transactions found for this date',
    game: 'Game / Source',
  },
  menu: {
    search: 'Search',
  },
  report: {
    startDay: "There's not open shift. Start a new one now.",
    startDayButton: 'Start shift.',
    confirm: 'Confirm',
    edit: ' Edit',
    cashin: 'Cashin',
    cashout: 'Cashout',
    neto: 'Neto',
    next: 'Next',
    back: 'Back',
    picture: ' Picture',
    errorTicket: 'You need to upload the tickets first.',
    capturePicture: 'Capture picture',
    resetCamera: 'Reset camera',
    date: 'Date',
    employee: 'Employee',
    miniSafeYesterday: 'Minisafe Yesterday',
    cashierYesterday: 'Cashier balance yesterday',
    cashierInOpening: 'Cashier balance at opening',
    difference: 'Difference',
    cashierTotal: 'Cashier total',
    cashierRefill: 'Cashier refill',
    sendReport: 'Send report',
    theoric: 'Theoric',
    minisafe: 'Minisafe',
    cashier: 'Cashier',
    deviated: 'Deviated',
    acceptDeviated: 'Accept deviated',
    closeReport: 'Daily report ',
  },
  endShift: {
    mainTitle: 'End of shift report',
    mainSubtitle:
      'Confirm the end of your shift will automatically manage all the reports and print the receipts. Do you want to continue?',
    title: 'Select one of the options:',
    subtitle:
      'You will need to do both, the card terminal report and the daily cashier report',
    cardReport: 'Card terminal report',
    cashierReport: 'Clubhouse report',
    winGamesReport: 'Win Games report',
    completed: 'Completed',
    notCompleted: 'Not completed',
    confirmCardReport: 'Do you want to confirm the card terminal report?',
    confirmWinGamesReport:
      'Do you want to confirm the win games terminal report?',
    cashin: 'Cash in',
    cashout: 'Cash out',
    neto: 'Neto',
    cardPayment: 'Betalinger utført med kort',
    cardPayout: 'Enkeltbetaling med kort',
    cardTotal: 'Totalt med kort',
    waiting: 'Processing the report, wait for a moment.',
    currentShift: 'Current Shift',
    day: 'Whole Day',
    cashierSection: 'Cashier',
    selfKioskSection: 'Self Kiosk',
    totalSection: 'Total',
    refunds: 'Refunds',
    paymentCash: 'Cash Payment',
    paymentCard: 'Card Payment',
    paymentAccount: 'Account Payment',
    cashWithdrawalRow: 'Cash withdrawal',
    tillMovements: 'Till movements',
    openingCashRow: 'Opening cash',
    movementsSum: 'Sum of movements',
    expectedInTill: 'Expected in the till',
    informational: 'For information — not counted',
    choiceTitle: 'End shift',
    choiceSubtitle: 'What would you like to do?',
    closeShift: 'Close shift',
    closeDay: 'Close the day',
    cashOnClosing: 'Cash on closing',
    back: 'Back',

    // Cash count, discrepancy and signature
    countTitle: 'Count the drawer',
    countSubtitle: 'Count the drawer and enter the amount you actually count.',
    countedLabel: 'Counted amount',
    countedHelp: 'Count before you see what the till expects.',
    showAvvik: 'Show discrepancy',
    expected: 'Expected',
    expectedUnknown: 'Not available',
    avvik: 'Discrepancy',
    avvikOver: 'Drawer is over',
    avvikUnder: 'Drawer is short',
    avvikNone: 'Drawer balances',
    avvikCommentLabel: 'Explanation for the discrepancy',
    avvikCommentHelp: 'Count again, or write what explains the difference.',
    avvikCommentRequired:
      'A discrepancy must be explained before the shift can be closed.',
    recount: 'Count again',
    ntNetto: 'NT net',
    rikstotoNetto: 'Rikstoto net',
    externalTillHelp:
      'Read the net off NT and Rikstoto and type it in. Zero is zero, but it has to be filled in.',
    externalNettoRequired:
      'NT and Rikstoto must be filled in, including when they are zero.',
    signTitle: 'Signature',
    signedByLabel: 'Name',
    signedByHelp: 'Type your name as it should appear on the receipt.',
    signConfirm:
      'I confirm that I have counted the drawer and that the amount above is correct.',
    signRequired: 'Type your name and confirm the count.',
    countMissing: 'Enter the counted amount.',
    draftRestored: 'Restored a count that was never finished.',
    noOpenShift: 'No open shift found to close.',
  },
  safe: {
    title: 'Safe and mini safe',
    miniSafe: 'Mini safe',
    safe: 'Safe',
    miniSafeIn: 'Put in',
    miniSafeOut: 'Take out',
    miniSafeCount: 'Count',
    countedToday: 'Counted today',
    notCountedToday: 'Not counted today',
    newBag: 'New money bag',
    toBank: 'To the bank',
    toBankSummary: '{{count}} bags to the bank, {{total}} kr in total.',
    bagCount: '{{count}} bags in the safe',
    noBags: 'No bags in the safe.',
    noBagsSelected: 'Select at least one bag.',
    bagNotFound: 'That bag is no longer in the safe.',
    amount: 'Amount',
    countedLabel: 'Counted amount',
    reason: 'Reason',
    note: 'Note',
    reference: 'Reference',
    referenceHelp: 'Deposit slip or reference number, if you have one.',
    reasonHelp: 'Write why the money is moving. Short is fine.',
    countHelp: 'Count the mini safe and enter what you actually find.',
    amountRequired: 'Enter an amount.',
    reasonRequired: 'A reason must be filled in.',
    insufficientBalance: 'There is not enough in the mini safe.',
    moveDone: 'The movement has been recorded.',
    countDone: 'The count has been recorded.',
    bagCreated: 'The bag has been placed in the safe.',
    bagsBanked: 'The bags have been sent to the bank.',
    bagCancelled: 'The bag has been undone.',
  },
  avslutteSkiftet: {
    closeTurn: 'Close turn',
    openTickets: 'Open tickets',
    yourTurn: 'Your turn',
    totalToday: 'Total today',
    paymentCash: 'Payment cash',
    paymentCard: 'Payment card',
    paymentAccount: 'Payment account',
    in: 'In',
    out: 'Out',
    net: 'Net',
    provider: 'Provider',
    amount: 'Amount',
    date: 'Date',
    ticketID: 'Ticket ID',
    closeOpenTicketsBtn: 'Close tickets',
    closeTurnTitle: 'Close your turn',
    closeTurnText1:
      'You are about to close your turn, do you want to continue? It will print the reports.',
    closeTurnText2:
      'If you are the last turn of the day, please close all the open tickets before closing your turn.',
    closeTurnConfirm: 'Your turn has been closed.',
    closeOpenTicketsTitle: 'Close open tickets',
    closeOpenTicketsText1:
      'You are about to close all the open tickets. This will empty the saldo of all the tickets. Do you want to continue?',
    closeOpenTicketsText2:
      'Please, be aware that the bingo should be closed and nobody is playing.',
    closeOpenTicketsText3: 'OK D. tickets must be closed manually.',
    closeOpenTicketsConfirm: 'All tickets have been closed.',
    notOpenTickets: 'There are no open tickets.',
  },
  socketStatus: {
    disconnectTitle: 'Connection lost',
    disconnectText:
      'The connection with the server has been lost. Trying to reconnect, keep waiting or call support.',
    reconnectTitle: 'Reconnected',
    reconnectTextNoTransactions:
      'The connection with the server has been reestablished. We recommend you to refresh the cashier.',
    reconnectTextTransactions:
      'The connection with the server has been reestablished. We recommend you to refresh the cashier after finish the current transactions.',
    refresh: 'Refresh now',
    notRefresh: "Don't refresh",
  },
  gameplan: {
    name: 'Game name',
    priceCard: 'Price card',
    gameID: 'Game ID',
    dateStart: 'Date start',
    printDraw: 'Print draw',
    winners: 'Winners',
    rop: 'Rop',
    cardNumber: 'Card number',
    userID: 'User ID',
    bingoName: 'Bingo name',
    playFrom: 'Play from',
    win: 'Win',
    dateEnd: 'End time',
    prizeType: 'Prize type',
    username: 'Username',
    firstname: 'First name',
    lastname: 'Last name',
    phone: 'Phone',
    guest: 'Guest',
    viaTicket: 'ticket',
  },
};
